// Route gate for a console page's navigation permission (agion/Agion#2556,
// F-ACC-02). The sidebar hides an entry whose permission the role lacks;
// this gate refuses the same page at its address, from the same server
// answer (GET /users/me/permissions, which auth-service builds from the shared
// role table platform/shared/consolenav). While the answer loads the page
// waits; without an answer the page is refused, never opened.
import React from 'react'
import { Navigate } from 'react-router'
import { Spinner } from '@agion/ui'
import { usePermissions, type NavigationPermissions } from './permission-context'

export type NavigationPage = keyof NavigationPermissions

export const NavigationGate: React.FC<{ page: NavigationPage; children: React.ReactNode }> = ({ page, children }) => {
  const { permissions, isLoading, canNavigateTo } = usePermissions()
  if (isLoading) {
    return (
      <div className="flex h-full items-center justify-center py-16" aria-busy="true" data-testid="navigation-gate-loading">
        <Spinner size="lg" />
      </div>
    )
  }
  if (!permissions || !canNavigateTo(page)) {
    return <Navigate to="/unauthorized" replace />
  }
  return <>{children}</>
}
